import { Grid, GridColumn, GridRow } from '@bp/ui-components';
import { memo, Suspense } from 'react';
import { CardControlModal } from '../../../../../components/TimetableGrid/CardControl/CardControlModal';
import { CardEditModal } from '../../../../../components/TimetableGrid/CardEditModal/CardEditModal';
import { CardInfo } from '../../../../../components/TimetableGrid/CardInfo/CardInfo';
import { CardPreview } from '../../../../../components/TimetableGrid/CardPreview/CardPreview';
import { ConflictModal } from '../../../../../components/TimetableGrid/ConflictModal/ConflictModal';
import { ConstraintModal } from '../../../../../components/TimetableGrid/ConstraintModal/ConstraintModal';
import { GenerateModal } from '../../../../../components/TimetableGrid/GenerateModal/GenerateModal';
import { GridActionArea } from '../../../../../components/TimetableGrid/GridActionArea/GridActionArea';
import { GridMenuBar } from '../../../../../components/TimetableGrid/GridMenuBar/GridMenuBar';
import { TestModal } from '../../../../../components/TimetableGrid/TestModal/TestModal';
import { TimetableGrid } from '../../../../../components/TimetableGrid/TimetableGrid';

export const Board = memo(() => {
  return (
    <div className='board-wrapper' id='timetable-grid'>
      <Grid>
        <GridRow spacingBottom='s'>
          <GridColumn width={8}>
            <GridMenuBar />
            <GridActionArea />
          </GridColumn>
          <GridColumn width={4}>
            <CardInfo />
          </GridColumn>
        </GridRow>
        <GridRow className='pinboard' spacingTop='s'>
          <TimetableGrid />
        </GridRow>
      </Grid>
      <CardPreview />
      <Suspense fallback={<></>}>
        <ConstraintModal />
      </Suspense>
      <CardControlModal />
      <TestModal />
      <GenerateModal />
      <CardEditModal />
      <ConflictModal />
    </div>
  );
});

Board.displayName = 'Board';
